var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"containers":_vm.containers,"fullPage":true},scopedSlots:_vm._u([{key:"signup-form",fn:function(){return [_c('Signup',{attrs:{"isReferralLink":_vm.isReferralLink,"isActivationLink":_vm.isActivationLink,"verifyUserLinkCode":_vm.verifyUserLinkCode,"isPasswordResetLink":_vm.isPasswordResetLink}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }